
import ownerSchemaLogger from '@wix/bi-logger-subscriptions-bm';
import visitorSchemaLogger from '@wix/bi-logger-subscriptions-bm';

const createBILogger = <TLogger>(
    schemaLogger: (webOrMobileLogger: any) => (userConfig?: any) => TLogger,
) => (factory: any) => (userConfig: any = {}) => {
  return schemaLogger(factory)(userConfig);
}

export const createOwnerBILogger = createBILogger(ownerSchemaLogger);
export const createVisitorBILogger = createBILogger(visitorSchemaLogger);
